import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Buefy from 'buefy'
import axios from 'axios';

Vue.use(Buefy, { defaultIconPack: 'far' });
Vue.config.productionTip = false



/* ROUTER MIDDLEWARE TO UPDATE ROLE STATE */
function getRole() {
  return new Promise((resolve, reject) => {
    axios.post(process.env.VUE_APP_API_URI + "/checkroute", {}, {
      headers: {
        authorization: localStorage.getItem('access_token')
      }
    }
    ).then(function (response) {
      resolve(response.data);
    }).catch(err => {
      reject(err);
    })
  })

}

router.beforeEach((to, from, next) => {
  // console.log('Checking route for ')
  // console.log(to)
  /* Init roles verification variables */
  let goTo = null;
  let authorized = false;
  let role = undefined;
  /* Find the desired route to visit */
  router.options.routes.map(function (route) {
    if (route.name == to.name) {
      goTo = route;
    }
  });
  /* Get & set the role */
  getRole().then(function (res) {
    role = res.role;
    store.state.role = role;
    store.state.email = res.email;
    store.state.weezy_id = res.weezy_id;
    store.state.fullname = res.fullname;
  }).catch(function () {
    if (localStorage.getItem('access_token')) {
      store.commit('logout')
    }

  }).then(
    function () {

      /* Check if authorized */

      if (!goTo.roles) {
        authorized = true
      } else {
        if (role) {
          let roles = role.split(',');
          for (let r of roles) {
            // Check if at least one of user's roles is authorized.
            if (goTo.roles.includes(r)) {
              authorized = true;
              break;
            }
          }
        }

      }

      /* Navigate */
      if (authorized) {
        next();
      } else {
        next({ path: "/login", query: { authorized: 'false' } });
      }
    }

  )


});


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
